module.exports = require('./$.hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.redefine.js
 ** module id = 17
 ** module chunks = 2
 **/